import React from 'react';

import { translate } from 'helpers/Translate';

import image404 from 'images/404-error.svg';

const NotFoundPage = () => (
    <div className="error-page text--center padding-double">
        <img src={image404} alt={translate('Erreur 404')} />
        <h1 className="error-page__main-title margin-top margin-bottom-quadruple">
            {translate('Ooops!')}
        </h1>
        <h2 className="error-page__title no-margin-top margin-bottom-double">
            {translate('Désolé, l’adresse que vous demandez est introuvable.')}
        </h2>
        <p className="error-page__subtitle no-margin-top margin-bottom-quadruple">
            {translate(
                'La page que vous avez demandée n’a pas été trouvée. Il se peut que le lien que vous avez utilisé soit rompu ou que vous ayez tapé l’adresse (URL) incorrectement.',
            )}
        </p>
        <a href="/">{translate('Retourner à la page d’accueil')}</a>
    </div>
);

NotFoundPage.displayName = 'NotFoundPage';

/**
 * NotFoundPage Functional Component.
 */
export default NotFoundPage;
